import { Modal } from "antd";
import React, { useCallback } from "react";
import baseService from "../../../../Service/baseService";

const DeleteModal = ({
  selectedId,
  deleteUrl,
  setIsShow,
  isShow,
  setUpdate,
  isOpen,
  onClose,
  onDelete,
  title = "Silme işlemi",
  description = "Silmek istediğinize eminmisiniz?"
}) => {
  const handleDelete = useCallback(() => {
    if (onDelete) {
      onDelete();
    } else {
      const service = new baseService();
      var url = "https://api.mobsmile.com/sulama/" + deleteUrl + selectedId;
      service.callServiceMethod(url, null, "DELETE").then((res) => {
        setUpdate((prev) => !prev);
        setIsShow((prev) => !prev);
      });
    }
  }, [deleteUrl, selectedId, setUpdate, onDelete]);

  const modalOpen = isOpen !== undefined ? isOpen : isShow;
  const modalClose = onClose || (() => setIsShow((prec) => !prec));

  return (
    <Modal
      title={title}
      open={modalOpen}
      destroyOnClose={true}
      footer={null}
      onCancel={modalClose}
    >
      <div>
        <h3 className="">{description}</h3>
        <div className="flex flex-wrap justify-end items-center mt-4">
          <button
            className="bg-red-500 hover:bg-red-700 px-4 py-2 me-3 rounded text-white "
            onClick={handleDelete}
          >
            Evet
          </button>
          <button
            className="bg-gray-500 hover:bg-gray-700 px-4 py-2 rounded text-white "
            onClick={modalClose}
          >
            Hayır
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
